/**
 * LoggedIn form component.
 *
 * @returns {JSX.Element}
 */
// State action for update/set rule config.
import {useDispatch} from "react-redux";
import {setRuleConfig} from "@app/modules/PersonaForm/store/PersonaFormStore";
import {useEffect} from "react";

export default function DesktopDevice() {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(
			setRuleConfig({
				id: "DesktopDevice",
				config: {
					ruleType: "device",
					args: {
						devices: ["desktop"],
					},
				},
			}),
		);
	}, []);

	return (
		<>
			<p>This rule targets desktop devices.</p>
		</>
	);
}
